export const NotificationLang = {
    notification: 'اعلان ها',
    emptyState: 'شما اکنون هیچ پیغامی ندارید',
    daysAgo: 'روز پیش',
    hoursAgo: ' ساعت پیش',
    minAgo: ' دقیقه پیش',
    secAgo: ' ثانیه پیش',
    rightNow: 'همین الان',
    new: 'جدید',
};
